const IdenticalParticleReducer = (state = {symmetrizationEnabled: true, groups: {}}, action) => {
    switch (action.type) {
        case 'SET_IDENTICAL_PARTICLES':
            return { ...state,
                groups: {...action.payload }
            };
        case "SET_SYMMETRIZATION":
            return { ...state,
                symmetrizationEnabled: action.payload
            };
        default:
            return state;
    }
}

export default IdenticalParticleReducer;
